// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yF8U","name":"Header_name__3SivD","birthday":"Header_birthday__3T2SI","skeleton":"Header_skeleton__3XZY5"};